import {
  Description,
  Field,
  Input as InputComponent,
  Label,
} from "@headlessui/react";
import clsx from "clsx";
import React from "react";

const Input = ({
  label,
  description,
  type = "text",
  className,
  value,
  onChange,
  name,
  width = "w-full",
  ...props
}) => {
  return (
    <div className={width}>
      <Field>
        {label && (
          <Label className="text-sm font-medium text-gray-700 pl-1">{label}</Label>
        )}
        {description && (
          <Description className="text-sm text-gray-400">
            {description}
          </Description>
        )}
        <InputComponent
          className={clsx(
            "block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-[#0B1120]",
            "focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 focus:outline-none",
            "placeholder:text-gray-400 transition-all duration-300",
            className
          )}
          type={type}
          value={value}
          onChange={onChange}
          name={name}
          {...props}
        />
      </Field>
    </div>
  );
};

export default Input;
